import React, { useEffect, useState } from "react";
import { BiExport, BiImport } from "react-icons/bi";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../Components/Loader";
import { destinationService, locationServices } from "../../Services";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
export const SeaDestinationChargeList = () => {
  const [loader, setLoader] = useState(true);
  const [listData, setListData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryValue, setCountryValue] = useState("");
  const [errcountry, SetErrcountry] = useState();

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // arry.push({ value: '', label: 'All country' })
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name });
        });
        const initialValue = res.data.filter(
          (res) => res.country_iso2 === "IN"
        )[0];
        setCountryValue({
          value: initialValue._id,
          label: initialValue.country_name,
        });
        setCountryList(arry);
      }
    });
  };

  const getItemList = (countryId = countryValue.value) => {
    setLoader(true);

    let param = {
      country_id: countryId ? countryId : "60ec38c6d19c537aaea07f0d",
    };

    destinationService.getSeaDestinationtariffs(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    getItemList();
    getCountryList();
  }, []);



  const onSelectCountry = (e) => {
    setCountryValue(e);
    getItemList(e.value);
  };

  // const onClickExport = () => {
  //     destinationService.exportLocalTariffData().then((res) => {
  //         console.log("res", res)
  //         if (res.status) {
  //             window.location.href = REACT_APP_API_BASEURL + '/' + res.data
  //             toast.success("file download successfully")
  //         } else {
  //             toast.error(res.message)
  //         }
  //     })
  // }



  const onClickExport = () => {
    setLoader(true);
    var errorcount = 0;

    if (countryValue.value === undefined) {
      SetErrcountry("*country is required.");
      errorcount++;
    }

    if (listData.length <= 0) {
      toast.error("No data found !");
      errorcount++;
    }

    let postData = {
      country_id: countryValue.value,
    };

    if (errorcount === 0) {

      destinationService.exportSeaDestinationData(postData).then((res) => {
        if (res.status) {
          window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
          toast.success("file download successfully");
          setLoader(false);

          // getItemList();
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  const onClickImport = (e) => {
  
    var Errcount = 0;

    if (countryValue.value === undefined) {
      SetErrcountry("*country is required.");
      Errcount++;
    }

    console.log("errCount", Errcount);

    const formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    formData.append("country_id", countryValue.value);

    if (Errcount === 0) {
      destinationService.importSeaDestinationData(formData).then((res) => {
        if (res.status) {
          getItemList();
          toast.success("file upload successfully");
        } else {
          toast.error(res.message);
        }
      });
    }
  };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with country..."
                    value={countryValue}
                    onChange={(e) => onSelectCountry(e)}
                    options={countryList}
                  />
                  {!countryValue.value && (
                    <div className="text-danger">{errcountry}</div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-end mb-3">
                <div>
                  <input
                    type="file"
                    id="upload"
                    accept=".csv"
                    hidden
                    onChange={(e) => onClickImport(e)}
                    onClick={(event) => {
                      event.target.value = null
                    }}
                  />
                  <label
                    for="upload"
                    className="btn btn-danger waves-effect waves-light mx-1 my-0"
                  >
                    <BiExport />
                    Upload File
                  </label>
                </div>
                <div>
                  <button
                    className="btn btn-success waves-effect waves-light mx-1 my-0"
                    onClick={() => onClickExport()}
                  >
                    <BiImport />
                    Download File
                  </button>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              {listData.length > 0 && (
                <table className="table table-centered table-nowrap mb-0">
                  <thead className="table-light">
                    <tr className="cutomTablewidth">
                      <th className="p-1 small">Destination cities</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => {
                          return (
                            <th className="p-1 small">
                              {list.destination_city_name}
                            </th>
                          );
                        })}
                    </tr>
                    <tr>
                      <th className="p-1 small">Port of entry</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.port_of_entry_name}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">NVOCC charged fixed</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.NVOCC_charges_fixed}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">NVOCC charged per CBM</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.NVOCC_charges_per_cmb}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">NVOCC charged per CBM minimum</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.NVOCC_charges_per_cmb_min}
                          </th>
                        ))}
                    </tr>
                    <tr>
                      <th className="p-1 small">Port Charges</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.port_charges}
                          </th>
                        ))}
                    </tr>
                    <tr>
                      <th className="p-1 small">Port Charges minimum</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.port_charges_min ? list.port_charges_min : 0}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">Custom clearance</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.customs_clearance}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">Bank charges</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.bank_charges}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">Quarantine fee</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.quarantine_fee}
                          </th>
                        ))}
                    </tr>

                    <tr>
                      <th className="p-1 small">Quarantine fee minimum</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.quarantine_fee_min}
                          </th>
                        ))}
                    </tr>


                  </thead>
                  <tbody>
                    {listData[0].cbm_array.map((item, key) => {
                      return (
                        <tr>
                          <th key={key} className="p-1 small">
                            CBM Transport Tariff : {item.cbm_value}
                          </th>
                          {listData.map((cmb, cmb_ind) => {
                            return (
                              <th key={cmb_ind} className="p-1 small">
                                {" "}
                                {cmb.cbm_array[key].cbm_price}
                              </th>
                            );
                          })}
                        </tr>
                      );
                    })}

                    <tr>
                      <th className="p-1 small">Every additional cbm</th>
                      {listData.length > 0 &&
                        listData.map((list, key) => (
                          <th key={key} className="p-1 small">
                            {list.every_additional_cbm}
                          </th>
                        ))}
                    </tr>
                  </tbody>
                </table>
              )}
              {listData.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2">No data available</h6>
                </div>
              )}
            </div>
          </div>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
  );
};
